import React, { ChangeEvent, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { FormattedMessage, useIntl } from "react-intl";

import { styles } from "./style";

import MobileImage from "@/assets/mobile.png";
import AppStoreIcon from "@/assets/appStore.png";
import PlayStoreIcon from "@/assets/playstore.png";

import { InputField } from "@/components/InputField";
import Button from "@/components/Button";

import { getAppDownloadLinkApi } from "@/utils/apis/patient/profile";
import { INotifyEnum, notify } from "@/utils/toaster";
import { appLinks } from "@/utils/Config";

const DownloadAppBanner: React.FC = () => {
  const [mobile, setMobile] = useState<string>("");
  const [appDownloadLoading, setAppDownloadLoading] = useState<boolean>(false);

  const intl = useIntl();

  const mobilehandler = (event: ChangeEvent<HTMLInputElement>) => {
    let value = event.target.value.replace(/\D/g, "");
    setMobile(value);
  };

  const downloadApplicationHandler = async () => {
    try {
      setAppDownloadLoading(true);
      const appDownloadLinkResponse = await getAppDownloadLinkApi(mobile);
      if ("result" in appDownloadLinkResponse) {
        notify(INotifyEnum.SUCCESS, appDownloadLinkResponse?.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setAppDownloadLoading(false);
      setMobile("");
    }
  };

  return (
    <Grid item sx={styles.container}>
      <Grid item sx={styles.mobileImageContainer}>
        <img src={MobileImage} alt="mobile image" />
      </Grid>
      <Grid item sx={styles.textContainer}>
        <Grid item sx={styles.downloadAppNowTitle}>
          <Typography component={"h4"}>
            <FormattedMessage
              id="download_the_app"
              defaultMessage="Download the App Now"
            />
          </Typography>
        </Grid>
        <Grid item sx={styles.appDescription}>
          <Typography component={"p"}>
            <FormattedMessage
              id="download_description"
              defaultMessage="Download description"
            />
          </Typography>
        </Grid>
        <Grid item sx={styles.getAppDownloadLink}>
          <InputField
            type="text"
            label={intl.formatMessage({
              id: "mobile_number",
              defaultMessage: "Mobile Number*",
            })}
            placeholder={intl.formatMessage({
              id: "mobile_number",
              defaultMessage: "Mobile Number*",
            })}
            inputProps={{
              maxLength: 10,
              inputMode: "numeric",
              pattern: "[0-9]*",
            }}
            value={mobile}
            onChange={mobilehandler}
          />

          <Button
            isLoading={appDownloadLoading}
            btnTrigger={downloadApplicationHandler}
            disabled={mobile?.length !== 10}
          >
            <FormattedMessage
              id="get_download_link"
              defaultMessage="Get Download Link"
            />
          </Button>
        </Grid>
        <Grid item sx={styles.downloadBtnContainer}>
          <Grid item sx={styles.playStoreIconContainer}>
            <Box
              component="button"
              onClick={() => window.open(appLinks?.android, "_blank")}
            >
              <Grid item>
                <img
                  src={PlayStoreIcon}
                  alt="store icon"
                  width={42}
                  height={42}
                />
              </Grid>
              <Grid item sx={styles.downloadBtnText}>
                <Typography component={"p"} sx={styles.downloadTextHeader}>
                  <FormattedMessage id="getit_on" defaultMessage="GET IT ON" />
                </Typography>
                <Typography component={"p"} sx={styles.downloadTextFooter}>
                  <FormattedMessage
                    id="google_play"
                    defaultMessage="Google Play"
                  />
                </Typography>
              </Grid>
            </Box>
          </Grid>
          <Box
            component="button"
            onClick={() => window.open(appLinks?.ios, "_blank")}
          >
            <Grid item>
              <img src={AppStoreIcon} alt="store icon" width={42} height={42} />
            </Grid>
            <Grid item sx={styles.downloadBtnText}>
              <Typography component={"p"} sx={styles.downloadTextHeader}>
                <FormattedMessage
                  id="download_on_the"
                  defaultMessage="Download on the"
                />
              </Typography>
              <Typography component={"p"} sx={styles.downloadTextFooter}>
                <FormattedMessage id="app_store" defaultMessage="App Store" />
              </Typography>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DownloadAppBanner;
